import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':entity/:category/:hash',
    title: ({ params }) => `File Proof - ${params['hash']?.substring(0, 6)}...`,
    loadComponent: () => import('./proofs/proofs.component'),
  },
  {
    path: 'ots-detail/:entity/:category/:hash',
    title: ({ params }) => `OTS Detail - ${params['hash']?.substring(0, 6)}...`,
    loadComponent: () => import('./ots/ots.component'),
  },
  {
    path: 'otsnavigator/:entity/:category/:hash',
    title: ({ params }) =>
      `OTS Navigator - ${params['hash']?.substring(0, 6)}...`,
    loadComponent: () => import('./navigator/navigator.component'),
  },
  {
    path: 'page-not-found',
    title: '404 - Not Found',
    loadComponent: () => import('./not-found/not-found.component'),
  },
  {
    path: '',
    redirectTo: '/page-not-found',
    pathMatch: 'full',
  },
];
